<template>
  <div class="config-container">
    <!-- Search and Action Section -->
    <div style="display: flex">
      <div>
        <el-input
            v-model="searchForm.key"
            clearable
            size="small"
            @clear="handleClear('key')"
            @input="handleSearch">
        </el-input>
      </div>
      <div style="padding-left: 10px;padding-right: 10px">
        <el-button type="primary" size="small" @click="fetchConfigs">查询</el-button>
      </div>
      <div>
        <el-button type="success" size="small" @click="showAddConfigDialog">新增配置</el-button>
      </div>
    </div>

    <el-table
        :data="configs"
        border
        style="width: 100%"
        @selection-change="handleSelectionChange">
      <el-table-column
          type="selection"
          width="55">
      </el-table-column>
      <el-table-column
          type="index"
          label="序号"
          width="60">
      </el-table-column>
      <el-table-column
          prop="setting"
          label="设置"
          width="100">
      </el-table-column>
      <el-table-column
          prop="value"
          label="值"
          width="60">
      </el-table-column>
      <el-table-column
          prop="startTime"
          label="生效时间"
          width="180">
        <template slot-scope="scope">
          {{ formatDate(scope.row.startTime) }}
        </template>
      </el-table-column>
      <el-table-column
          prop="endTime"
          label="失效时间"
          width="180">
        <template slot-scope="scope">
          {{ formatDate(scope.row.endTime) }}
        </template>
      </el-table-column>
      <el-table-column
          label="操作"
          width="120">
        <template slot-scope="scope">
          <el-button size="mini" @click="showEditConfigDialog(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>


    <!-- Pagination Section -->
    <el-pagination
        @current-change="handleCurrentChange"
        :current-page="this.currentPage"
        :page-size="this.pageSize"
        layout="total, prev, pager, next, jumper"
        :total="this.totalConfigs">
    </el-pagination>
    <el-dialog
        title="新增配置"
        :visible.sync="dialogVisible"
        width="30%"
        @close="resetForm"
    >
      <el-form ref="form" :model="form" label-width="120px">
        <el-form-item label="配置键" prop="setting">
          <el-input v-model="form.setting"></el-input>
        </el-form-item>
        <el-form-item label="配置值" prop="value">
          <el-input v-model="form.value"></el-input>
        </el-form-item>
        <el-form-item label="生效时间" prop="startTime">
          <el-date-picker v-model="form.startTime" type="datetime" placeholder="选择日期时间"></el-date-picker>
        </el-form-item>
        <el-form-item label="失效时间" prop="endTime">
          <el-date-picker v-model="form.endTime" type="datetime" placeholder="选择日期时间" ></el-date-picker>        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitForm('form')">确 定</el-button>
    </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import { Message } from 'element-ui';

export default {
  name: "ConfigView",
  data() {
    return {
      dialogVisible: false,
      form: {
        setting: '',
        value: '',
        // 添加其他字段
      },
      searchForm: {
        key: ''
      },
      configs: [],
      totalConfigs: 0,
      currentPage: 1,
      pageSize: 10,
      multipleSelection: []
    };
  },
  methods: {
    async processUpdateConfig() {
      try {
        const config = {
          id: this.form.id,
          setting: this.form.setting,
          value: this.form.value,
          startTime: this.form.startTime,
          endTime: this.form.endTime,
        };

        const response = await axios.put('/api/admin/config/update', config, {
          headers: {
            'token': this.$cookies.get('token'),
            'Content-Type': 'application/json'
          }
        });

        if (response.data.code === 200) {
          this.$message({
            type: 'success',
            message: '配置更新成功!'
          });
          await this.fetchConfigs();
        } else {
          this.$message.error('更新失败');
        }
      } catch (error) {
        this.$message.error('更新配置时发生错误: ' + error.message);
      }
    },
    showEditConfigDialog(row) {
      this.form = Object.assign({}, row); // This will copy the data from the row to the form
      this.dialogVisible = true;
    },
    handleSelectionChange() {

    },
    async fetchConfigs() {
      try {
        const response = await axios.post(`/api/admin/config/page`, {
          current: this.currentPage, // 确保使用更新后的当前页码
          size: this.pageSize,
          setting: this.searchForm.key
        }, {
          headers: {
            'token': this.$cookies.get('token')
          }
        });
        this.configs = response.data.data;
        this.totalConfigs = response.data.total;
      } catch (error) {
        Message.error('Error fetching configs: ' + error.message);
      }
    },
    handleSearch() {
      this.fetchConfigs();
    },
    handleClear(attribute) {
      this.searchForm[attribute] = '';
      this.handleSearch();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchConfigs();
    },
    formatDate(date) {
      return date ? new Date(date).toLocaleDateString() : '';
    },
    showAddConfigDialog() {
      this.dialogVisible = true;
    },
    resetForm() {
      this.$refs['form'].resetFields();
    },
    async submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.form.id) {
            this.processUpdateConfig();
          } else {
            this.processAddConfig(this.form.setting, this.form.value);
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
      this.dialogVisible = false;
    },
    async processAddConfig(setting, configValue) {
      try {
        const config = {
          setting: this.form.setting,
          value: this.form.value,
          // 这里你可能需要添加startTime和endTime字段，我暂时将它们设为null
          startTime: this.form.startTime ? Date.parse(this.form.startTime) : null,
          endTime: this.form.endTime ? Date.parse(this.form.endTime) : null,
        };

        const response = await axios.post('/api/admin/config/save', config, {
          headers: {
            'token': this.$cookies.get('token'),
            'Content-Type': 'application/json'
          }
        });

        if (response.data.code === 200) {
          this.$message({
            type: 'success',
            message: '配置添加成功!'
          });
          await this.fetchConfigs();
        } else {
          this.$message.error('添加失败');
        }
      } catch (error) {
        this.$message.error('添加配置时发生错误: ' + error.message);
      }
    },
  },
  mounted() {
    this.fetchConfigs();
  }
}
</script>

<style scoped>
.config-container .el-table th {
  background-color: #f5f7fa;
}
.config-container /deep/ .el-table td, .config-container /deep/ .el-table th {
  padding: 8px 0;
}
.config-container /deep/ .el-table .cell {
  line-height: 30px;
}
</style>
